import React from 'react';
import { layout } from 'Constants';

// Components
import { Container, Anchor, Button } from 'Components/core';
import Hero from './components/Hero';
import Cards from './components/Cards';
import InfoBox from 'Components/InfoBox';

// Images
import AppStoreIOS from './images/appstore_logo@2X.png';
import AppStoreAndroid from './images/playstore_logo@2X.png';
import Connect from './images/OE_Page_Title.jpeg';
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Root/store';
import CODES from 'Root/libs/analytics/CodeDef';
import Alert from './components/Alert';
import ContainterV2 from 'Components/core/ContainterV2';
import { toHumanReadable } from 'Libs/date';
import styled from 'styled-components';
import MobileMock from './images/mobile mock@2X.png';
import ReadyEnrollImage from './images/ready_to_enroll@2X.png';
import VideoImage from './images/videoImage.png';
import Thumb from './images/thumb.svg';

export default () => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <Container column>
        <ContainterV2
        centered={true}
          heroText="Choosing And Using Your Plan"
          longText=<span>
            Now is the perfect time to think about your health — where you are
            right now and where you want to be tomorrow. Take time to explore
            the benefits, programs and resources that can support your health
            and well-being all year long.
            {isNaN(state?.oeMaterials?.oeStart) == false &&
              state?.oeMaterials?.oeStart != null && (
                <p>
                  <strong>
                    {' '}
                    Open enrollment runs from{' '}
                    {toHumanReadable(state?.oeMaterials?.oeStart)}{' '}
                    {isNaN(state?.oeMaterials?.oeEnd) == false ? ' to ' : ''}
                    {toHumanReadable(state?.oeMaterials?.oeEnd)}
                  </strong>{' '}
                </p>
              )}
          </span>
        ></ContainterV2>

        <Container
          seperation="32px"
          column
          margin="32px auto"
          style={{
            maxWidth: layout.maxWidth,
            width: '100%'
          }}
        >
          <Cards />
          <ConnectPanel state={state} />
          <ReadyToEnrollPanel state={state} />
          {false && <HomeVideoPanel state={state} />}
          <ISHelpFulPanel state={state} />
        </Container>
      </Container>
    )}
  </Subscribe>
);

const ConnectPanelOuter = styled.div`
  height: 378px;
  background: transparent;
  display: flex;
  margin-top: 40px;
  flex-wrap: wrap-reverse;
  //background-color:red ;
 
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    margin-top: 300px;
  }
`;
const ConnectPanelHeader = styled.h2`
  /* Resets the spacing */
  margin: 0;
  padding: 0;
  
  /* Ensures it behaves as a block (divs are block by default) */
  display: block;
  
  /* Optional: removes any other browser-specific defaults */
  line-height: inherit;
  color: inherit;
  font-family: 'Elevance Sans Semibold';
  font-size: 36px;
  line-height: 48px;
  text-align: left;
  color: #fff;
  margin-bottom: 15px;
  display: block;
`;
const ConnectPanelText = styled.div`
  width:100%;
  font-family: 'Elevance Sans Regular';
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: left;
  color: #fff;
  margin-bottom: 15px;
`;
const ConnectPanelInner = styled.div`
  flex: 1;
  height: 318px;
  background: #286ce2;
  padding: 50px 100px 50px 100px;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    padding: 50px 25px 50px 25px;
    height: auto;
  }
`;

const ConnectImage = styled.div`
  position: relative;
  background: #286ce2;
  flex: 1;
  height: 318px;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    height: 100px;
    background-color: transparent;
  }
  > img {
    position: absolute;
    bottom: 0px;

    width: 588px;
    @media screen and (max-width: ${layout.breakpoints.mobile}) {
      width: 100vw;
    }
  }
`;

const AppStoreLinkHolder = styled.div`
  margin-top: 20px;
  width: 65%;
  max-width: 300px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const ConnectPanel = ({ state }) => {
  return (
    <ConnectPanelOuter>
      <ConnectPanelInner>
        <ConnectPanelHeader>Connect to better health with the {state.mobileAppInfo?.appName} app.</ConnectPanelHeader>
        <ConnectPanelText>
 


          Once you have an   {state.brandInfo.name} health plan, you’ll be able to access your benefits and digital health plan ID card, wellness resources, and the Find Care tool with the <b>{state.mobileAppInfo?.appName}</b> app.


          <AppStoreLinkHolder>
            <Anchor code={CODES.HOME_DL_APPLE} to={state.mobileAppInfo?.ios}>
              <img
                alt="App Store"
                style={{ alignSelf: 'center', height: '52px' }}
                src={AppStoreIOS}
              />
            </Anchor>

            <Anchor code={CODES.HOME_DL_PLAY} to={state.mobileAppInfo?.android}>
              <img
                alt="Play Store"
                style={{ alignSelf: 'center', height: '52px' ,marginLeft:10}}
                src={AppStoreAndroid}
              />
            </Anchor>
          </AppStoreLinkHolder>
        </ConnectPanelText>
      </ConnectPanelInner>
     
    </ConnectPanelOuter>
  );
};

const ReadyToEnrollHeader = styled.div`
  font-family: 'Elevance Sans Semibold';
  font-weight: 600;
  font-size: 36px;
  line-height: 48px;
  text-align: left;
  color: #1a3673;
`;

const ReadyToEnrollRight = styled(Container)`
  width: 53%;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const ReadyToEnrollText = styled.div`
  font-family: 'Elevance Sans Regular';

  font-size: 18px;
  line-height: 26px;
  text-align: left;
  color: #131331;
`;

const ReadyToEnrollImage = styled.img`
  width: 209px;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    position: absolute;
    height: 40px;
    right: 20px;

    width: auto;
  }
`;

const ReadyToEnrollPanel = ({ state }) => {


  if(state?.includeBenefitsAdministrator==false || state?.includeBenefitsAdministrator==undefined)
  {
  //  return "xxx";
  }


  return (
    <Container style={{ marginTop: 40 }} justifyContent="center">
      <ReadyToEnrollRight row wrap>
        <Container>
          <ReadyToEnrollImage src={ReadyEnrollImage} />
        </Container>
        <Container
          style={{ marginLeft: 20 }}
          flex={1}
          justifyContent="space-around"
          column
        >
          <ReadyToEnrollHeader>Ready to enroll?</ReadyToEnrollHeader>
          <ReadyToEnrollText>
            {state?.oeMaterials?.enrollPara ? (
              <p>{state.oeMaterials.enrollPara}</p>
            ) : (
              <>
                {' '}
                Stay tuned, your Benefits Administrator or Human Resources
                Representative will contact you soon with specific enrollment
                instructions for your organization. Then just follow those steps
                to join one of our plans.
              </>
            )}
          </ReadyToEnrollText>

          <Container style={{ marginTop: 10 }}>
            {typeof state.oeMaterials?.enrollURL === 'string' ? (
              <Button
                code={CODES.READY_TO_ENROLL}
                to={state.oeMaterials.enrollURL}
                underline={false}
              >
                Sign Up Today
              </Button>
            ) : (
              <></>
            )}
          </Container>
        </Container>
      </ReadyToEnrollRight>
    </Container>
  );
};

const HomeVideoTitle = styled.div`
  font-family: 'Elevance Sans Semibold';
  font-weight: 600;
  font-size: 36px;
  line-height: 48px;
  text-align: center;
  color: #1a3673;
`;
const HomeVideoText = styled.div`
  max-width: 516px;

  font-family: 'Elevance Sans Regular';
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  color: #131331;
  margin-top: 10px;
  //background-color: red;
`;
const HomeVideo = styled.div`
  flex: 1;

  > img {
    max-width: 682px;
    width: 100%;
    height: auto;
    @media screen and (max-width: ${layout.breakpoints.mobile}) {
      width: 100vw;
    }
  }
`;
const HomeVideoRight = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  //background-color:yellow ;
  align-items: center;
  justify-content: center;
`;

const HomeVideoPanel = state => {
  return (
    <Container wrap style={{ backgroundColor: '#F5F5F5', marginTop: 40 }}>
      <HomeVideo>
        <img src={VideoImage} alt="Video thumbnail" />
      </HomeVideo>
      <HomeVideoRight>
        <HomeVideoTitle>Video title here</HomeVideoTitle>
        <HomeVideoText>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate ve.
        </HomeVideoText>
      </HomeVideoRight>
    </Container>
  );
};

const HelpFulText = styled.div`
  font-family: 'Elevance Sans Semibold';
  font-weight: 600;
  font-size: 36px;
  line-height: 48px;
  text-align: center;
  color: #1a3673;
  margin-top:10px;
  margin-bottom:15px ;
`;

const ISHelpFulPanelContainer = styled.div`
  max-width: 326px;
  display: flex;
  flex-direction: column;
  align-self: center;
  margin-top:60px ;
  margin-bottom:30px ;
`;

const ThumbImage = styled.img`
  height: 60px;
  width: 60px;
  margin: 5px;
  ${props => (props.inverted ? 'transform: scale(-1, -1);' : '')};
`;

const ISHelpFulPanel = ({ state }) => {
  return (
    <ISHelpFulPanelContainer  >
      <Container justifyContent="center">
        <ThumbImage src={Thumb} alt="Thumb" />
        <ThumbImage src={Thumb} inverted alt="Thumb inverted" />
      </Container>
      <HelpFulText>Is the information on this site helpful? </HelpFulText>
      <Container justifyContent="center">
        <Button   code={CODES.EXT_CLICK} to={state?.brandInfo?.surveyLink}>Let us Know</Button>
      </Container>
    </ISHelpFulPanelContainer>
  );
};
